import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import ProposalMoreRequest from '../../../widgets/moreRequest/ProposalMoreRequest'
import PetitionMoreRequest from '../../../widgets/moreRequest/PetitionMoreRequest'
import { getChangeAgreement } from '../../../redux/actions/contract'
import { startLoading, doneLoading } from '../../../utils/loading'

export default function MoreRequest() {
  //มีคำร้องขอทำข้อต้องลงเพิ่มเติม
  const [isEditWidget, setIsEditWidget] = useState({})
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    projectId && handleGetSchema(projectId)
  }, [])

  const handleGetSchema = async (projectVersionId) => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getChangeAgreement(projectVersionId)
      setSchema(response.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal statusDefault={8}>
        <ContentHeader header={schema?.header} subHeader={schema?.subHeader} />
        {schema && (
          <>
            <AgreementAdditionalWidgets
              showCommandButton={true}
              formSchema={schema.forms.agreementDetails}
            />

            <ProposalMoreRequest
              schema={schema.forms.projectFeedback}
              schemaButton={schema.forms}
              onSuccess={() => handleGetSchema(projectId)}
            />

            {schema?.forms?.requestNote?.note && (
              <PetitionMoreRequest showCommandButton={true} schema={schema.forms.requestNote} />
            )}
          </>
        )}
      </SidebarProposal>
    </>
  )
}
